import Dashboard from '../containers/dashboard'
import DocumentsCompletedManagement from '../containers/documents-completed-management'

const DocumentsCompleted = () => {
  return (
    <Dashboard>
      <DocumentsCompletedManagement />
    </Dashboard>
  )
}

export default DocumentsCompleted
